import { Component } from '@angular/core';
import { bootstrapEnvelope, bootstrapTelephone } from '@ng-icons/bootstrap-icons';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { ionLocationOutline } from '@ng-icons/ionicons';

@Component({
  selector: 'app-contact-us',
  imports: [ NgIcon ],
  templateUrl: './contact-us.component.html',
  styles: ``,
  viewProviders: [provideIcons({ bootstrapTelephone, ionLocationOutline, bootstrapEnvelope })],
})
export class ContactUsComponent {

}
